import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import FormField from 'components/@common/Inputs/FormField';
import {
  Organization,
  OrganizationLicenseUsage,
  OrganizationRole
} from 'types/schema-generated-types';
import OrganizationRolesPicker from '../../../components/OrganizationRolesPicker';
import EducatorProductsPicker from '../../../components/EducatorProductsPicker';

interface InviteUserFormProps {
  licenseUsage: OrganizationLicenseUsage[];
  organizations?: Organization[];
  organizationRoles: OrganizationRole[];
}

const InviteUserForm: React.FC<InviteUserFormProps> = props => {
  const { t } = useTranslation();
  const { licenseUsage, organizations, organizationRoles } = props;
  return (
    <Grid container spacing={4}>
      <Grid item xs={4}>
        <FormField name="firstName" label={t('First Name', { ns: '@common' })} />
        <FormField name="lastName" label={t('Last Name', { ns: '@common' })} />
        <FormField name="email" label={t('E-mail Address', { ns: '@common' })} />
        <OrganizationRolesPicker
          organizations={organizations}
          organizationRoles={organizationRoles}
        />
      </Grid>
      <Grid item xs={6}>
        <EducatorProductsPicker licenseUsage={licenseUsage} />
      </Grid>
    </Grid>
  );
};

export default InviteUserForm;
